import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import React from "react";


const ConfirmUserModal = ({
  confirmOpen, 
  cancelConfirm, 
  changesSummary, 
  renderStates,
  confirmSave} : {
    confirmOpen: boolean; 
    cancelConfirm: () => void; 
    changesSummary: { field: string; before: string | string[] | null; after: string | string[] | null }[]; 
    renderStates: (stateCodes: string[]) => string;
    confirmSave: () => void;
  }) => {
  return (
    <Dialog open={confirmOpen} onClose={cancelConfirm} maxWidth="sm" fullWidth>
        <DialogTitle>Confirm Changes</DialogTitle>
        <DialogContent dividers>
          {changesSummary.length ? (
            <Box component="ul" sx={{ pl: 3, m: 0 }}>
              {changesSummary.map((c, idx) => (
                <li key={idx}>
                  <Typography variant="body2">
                    <strong>{c.field}</strong>: {Array.isArray(c.before) ? renderStates(c.before) : String(c.before || '—')} → {Array.isArray(c.after) ? renderStates(c.after) : String(c.after || '—')}
                  </Typography>
                </li>
              ))}
            </Box>
          ) : (
            <Typography variant="body2">No changes detected.</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelConfirm}>Cancel</Button>
          <Button variant="contained" color="primary" onClick={confirmSave} disabled={!changesSummary.length}>
            Confirm & Save
          </Button>
        </DialogActions>
      </Dialog>
  );
}

export default ConfirmUserModal;